import { render } from "./BookmarkFilterTags.vue?vue&type=template&id=56a484bd&scoped=true"
import script from "./BookmarkFilterTags.vue?vue&type=script&lang=js"
export * from "./BookmarkFilterTags.vue?vue&type=script&lang=js"

import "./BookmarkFilterTags.vue?vue&type=style&index=0&id=56a484bd&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a484bd"]])

export default __exports__